import { render, staticRenderFns } from "./ProjectModalWithButton.vue?vue&type=template&id=298682f4"
import script from "./ProjectModalWithButton.vue?vue&type=script&lang=ts"
export * from "./ProjectModalWithButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('298682f4')) {
      api.createRecord('298682f4', component.options)
    } else {
      api.reload('298682f4', component.options)
    }
    module.hot.accept("./ProjectModalWithButton.vue?vue&type=template&id=298682f4", function () {
      api.rerender('298682f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ProjectModalWithButton.vue"
export default component.exports